import { css } from '@/styled-system/css';

export const container = css({
  display: 'flex',
  flexDirection: 'column',
  gap: '2x',
});

export const reportSection = css({
  display: 'flex',
  flexDirection: 'column',
  gap: '1x',
});

export const reportHeading = css({
  fontSize: 'sm',
  fontWeight: '700',
  color: 'hpxBlue600',
});

export const reportDescription = css({
  fontSize: 'sm',
  color: 'hpxGrey600',
  lineHeight: '1.5',
});

export const reportLink = css({
  fontSize: 'sm',
  fontWeight: '600',
  color: 'hpxTeal500',
  cursor: 'pointer',
  background: 'none',
  border: 'none',
  padding: '0',
  textAlign: 'left',
  _hover: {
    color: 'hpxTeal600',
    textDecoration: 'underline',
  },
});

export const actionRow = css({
  display: 'flex',
  alignItems: 'center',
  gap: '1x',
});

export const separator = css({
  fontSize: 'sm',
  color: 'hpxGrey500',
});
